import RiskPage from '@/modules/dashboard/risk/risk-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/risk/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <RiskPage />;
}
